import { useQuery } from '@tanstack/react-query'

import { getDcQueryOptions } from '@/features/dcs/query-options'

/**
 * 単一拠点(物流センター)取得のUseQuery
 * dcId が未指定の間は fetch しない
 */
export const useDcQuery = (tenantKey: string, dcId: number | undefined) => {
  return useQuery({
    ...getDcQueryOptions(tenantKey, dcId ?? 0),
    enabled: dcId !== undefined,
    retry: false
  })
}
